import { inject, observer } from 'mobx-react'
import PropTypes from 'prop-types'

import { ReactComponent as HeyNicIcon } from '../../../assets/icons/HeyNicIconOnly.svg'
import AdviceStepChat from './AdviceStepChat'
import { PanelSlot, PanelCard, PullTab } from './styled'

/*
 * Desktop: the chatbot lives in a side panel beside step-by-step advice, expanded
 * by default. Closing it collapses the panel to zero width — the step content
 * slides back out to fill the space — and leaves a pull tab against the right
 * edge to bring it back.
 *
 * The panel stays mounted while collapsed so reopening it costs neither the
 * transcript nor a re-fetch, and so both directions animate.
 */
const AdviceHeyNicPanel = ({ store, stepPath, stepLabel, showInput, onCaseRefresh }) => {
  const open = store.advicePanelOpen

  return (
    <>
      {/* Collapsed it is 0-wide but still in the DOM, so `inert` keeps its close
          button and pills out of the tab order and off assistive tech. */}
      <PanelSlot open={open} inert={!open} aria-hidden={!open}>
        <PanelCard>
          <AdviceStepChat
            stepPath={stepPath}
            stepLabel={stepLabel}
            showInput={showInput}
            onCaseRefresh={onCaseRefresh}
            onClose={() => store.setAdvicePanelOpen(false)}
          />
        </PanelCard>
      </PanelSlot>

      {!open && (
        <PullTab
          type='button'
          onClick={() => store.setAdvicePanelOpen(true)}
          aria-label='Open Hey Nic'>
          <HeyNicIcon />
        </PullTab>
      )}
    </>
  )
}

AdviceHeyNicPanel.propTypes = {
  stepPath: PropTypes.string.isRequired,
  stepLabel: PropTypes.string,
  /** Show the free-text field (summary step only). */
  showInput: PropTypes.bool,
  onCaseRefresh: PropTypes.func,
}

export default inject('store')(observer(AdviceHeyNicPanel))
